<div class="error-page">
	<h1>Désolé, vous n'avez pas accés à cette page.</h1>
	<a (click)="retourAccueil()" class="link">Retour à l'accueil</a>
</div>
